import { render, staticRenderFns } from "./ResultsActions.vue?vue&type=template&id=3c66fffb&scoped=true"
import script from "./ResultsActions.vue?vue&type=script&lang=js"
export * from "./ResultsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66fffb",
  null
  
)

export default component.exports